<template>
  <div>
    <SiteHeader />
    <div class="page flex-col">
      <img
        class="image_1"
        referrerpolicy="no-referrer"
        src="../lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png"
      />
      <div class="section_1 flex-col">
        <div class="block_3 flex-col">
          <div class="group_3 flex-row">
            <div class="text-group_1 flex-col">
              <span class="text_13">传播与平台</span>
              <span class="text_14">新闻与传播研究所长期重视高端学术传播平台建设，逐步形成期刊、年鉴、辑刊与数字传播协同发展的传播格局。</span>
            </div>
          </div>
          <div class="text-wrapper_2">
            <span class="text_15">
              <router-link to="/lanhu_shouye" style="color: inherit; text-decoration: none;">首页</router-link>
              &nbsp;&gt;&nbsp;
              <router-link to="/lanhu_chuanboyupingtai" style="color: inherit; text-decoration: none;">传播与平台</router-link>
              &nbsp;&gt;&nbsp;
            </span>
            <span class="text_16">传播平台</span>
          </div>
          <div class="group_4 flex-col"></div>
          <div class="group_5 flex-row justify-between">
            <div class="sidebar-slot">
              <SidebarAccordion
                :sections="sidebarSections"
                active-section-id="communication"
                active-item-id="communication-platform"
              />
            </div>
            <div class="group_7 flex-col content-slot">
              <div class="text-wrapper_4 flex-col"><span class="text_19">传播平台</span></div>

              <div class="content-shell">
                <section class="overview-card">
                  <p class="eyebrow">栏目总览</p>
                  <h2 class="overview-title">以“一刊两鉴两辑刊”为主体的学术传播格局</h2>
                  <p class="overview-text">
                    建所至今，历任领导都高度重视本所高端学术传播平台的营建和优化，带领所内编辑职岗的同仁先后创办了《新闻研究资料》《中国新闻年鉴》《报纸工作研究参考资料》《新闻法通讯》《新闻学刊》《新闻与传播研究》等专业期刊。
                  </p>
                  <p class="overview-text">
                    近年来，又推出了《新闻学传播学文摘》《治学例话——全国新闻传播学优秀论文品鉴》《中国新闻传播学年鉴》等创新力作，为学界提供了更为丰富的成果载体和交流平台。
                  </p>
                  <p class="overview-text">
                    目前，本所已经形成以『一刊两鉴两辑刊』为主体的学术传播格局。《新闻与传播研究》成为国内本学科最具影响力的学术刊物，在引领学术方向上成绩显著。
                  </p>

                  <div class="summary-grid">
                    <article
                      v-for="group in summaryGroups"
                      :key="group.title"
                      class="summary-card"
                    >
                      <p class="summary-card__label">{{ group.title }}</p>
                      <h3 class="summary-card__title">{{ group.name }}</h3>
                      <p class="summary-card__desc">{{ group.description }}</p>
                    </article>
                  </div>
                </section>

                <section class="entry-section">
                  <div class="entry-section__header">
                    <div>
                      <p class="eyebrow">栏目入口</p>
                      <h2 class="overview-title overview-title--compact">传播平台各子页</h2>
                    </div>
                  </div>

                  <div class="entry-grid">
                    <router-link
                      v-for="item in platformItems"
                      :key="item.title"
                      :to="item.route"
                      class="entry-card"
                    >
                      <p class="entry-card__tag">{{ item.tag }}</p>
                      <h3 class="entry-card__title">{{ item.title }}</h3>
                      <p class="entry-card__desc">{{ item.description }}</p>
                      <span class="entry-card__more">查看页面</span>
                    </router-link>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SiteFooter
        :notch-width="704"
        notch-left="calc((100vw - 1300px) / 2 + 445px)"
      />
    </div>
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue';
import SiteFooter from '@/components/SiteFooter.vue';
import SidebarAccordion from '@/components/SidebarAccordion.vue';
import { createSidebarSections } from '@/config/secondarySidebar';

export default {
  name: 'LanhuChuanboyupingtai',
  components: {
    SiteHeader,
    SiteFooter,
    SidebarAccordion
  },
  data() {
    return {
      sidebarSections: createSidebarSections({
        activeSectionId: 'communication',
        activeItemId: 'communication-platform'
      }),
      summaryGroups: [
        {
          title: '一刊',
          name: '《新闻与传播研究》',
          description: '国内本学科最具影响力的学术刊物，持续引领新闻传播学学术研究方向。'
        },
        {
          title: '两鉴',
          name: '《中国新闻年鉴》与《中国新闻传播学年鉴》',
          description: '系统记录新闻事业发展变化与新闻传播学研究成果，构成重要资料性载体。'
        },
        {
          title: '两辑刊',
          name: '《治学例话》与《新闻学传播学文摘》',
          description: '围绕优秀论文与年度代表性观点展开整理与传播，扩大学术成果影响。'
        },
        {
          title: '平台延展',
          name: '研究网与微信公号',
          description: '通过网站和新媒体窗口持续输出学术资讯、成果动态与专题内容。'
        }
      ],
      platformItems: [
        {
          tag: '旗舰期刊',
          title: '《新闻与传播研究》',
          description: '本学科最具影响力的核心学术刊物。',
          route: '/new/lanhu_xinwenyuchuanboyanjiu'
        },
        {
          tag: '资料年刊',
          title: '《中国新闻年鉴》',
          description: '记录我国新闻事业发展变化的大型资料性年刊。',
          route: '/new/lanhu_zhongguoxinwennianjian'
        },
        {
          tag: '学术年鉴',
          title: '《中国新闻传播学年鉴》',
          description: '集中呈现我国新闻传播学研究成果的学术年鉴。',
          route: '/new/lanhu_zhongguoxinwenchuanboxuenianjian'
        },
        {
          tag: '优秀论文',
          title: '《治学例话》系列',
          description: '全国新闻传播学优秀论文遴选成果的系列文集。',
          route: '/new/lanhu_zhixuelihuaxilie'
        },
        {
          tag: '学术文摘',
          title: '《新闻学传播学文摘》',
          description: '精选年度代表性文章和学术观点的文摘新品。',
          route: '/new/lanhu_xinwenxuechuanboxuewenzhai'
        },
        {
          tag: '网站平台',
          title: '新闻与传播研究网',
          description: '研究所的重要线上传播平台与专题入口集合。',
          route: '/new/lanhu_xinwenyuchuanboyanjiuwang'
        },
        {
          tag: '新媒体窗口',
          title: '“新闻与传播学术前沿”微信公号',
          description: '面向学界和公众持续发布成果与动态的重要窗口。',
          route: '/new/lanhu_xinwenyuchuanboxueshuqianyan'
        }
      ]
    };
  }
};
</script>

<style scoped lang="css" src="../lanhu_jigouyulishi/assets/index.css" />
<style scoped>
.section_1 {
  min-height: auto;
}

.block_3 {
  min-height: auto;
  padding-bottom: 88px;
}

.group_3 {
  padding-bottom: 36px;
}

.text_14 {
  height: auto;
}

.group_5 {
  align-items: flex-start;
}

.sidebar-slot {
  width: 274px;
  flex: 0 0 274px;
}

.sidebar-slot :deep(.sidebar-accordion) {
  width: 100%;
}

.content-slot {
  flex: 1;
  min-width: 0;
}

.content-shell {
  display: grid;
  gap: 28px;
}

.overview-card,
.entry-section {
  padding: 28px;
  border-radius: 12px;
  border: 1px solid rgba(179, 145, 101, 0.18);
  background:
    linear-gradient(140deg, rgba(248, 242, 233, 0.82), rgba(255, 255, 255, 0) 40%),
    linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(251, 249, 245, 0.98));
  box-shadow: 0 14px 30px rgba(59, 41, 17, 0.05);
}

.entry-section {
  background:
    linear-gradient(140deg, rgba(243, 247, 250, 0.82), rgba(255, 255, 255, 0) 42%),
    linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(252, 250, 246, 0.95));
}

.eyebrow {
  margin: 0 0 10px;
  color: #b28a56;
  font-size: 12px;
  line-height: 1.4;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.overview-title {
  margin: 0 0 16px;
  color: #f25c19;
  font-size: 28px;
  line-height: 1.4;
  font-family: 'Songti SC', 'STSong', 'Noto Serif SC', serif;
  font-weight: 700;
}

.overview-title--compact {
  font-size: 24px;
  margin-bottom: 0;
}

.overview-text {
  margin: 0 0 14px;
  color: #231f20;
  font-size: 15px;
  line-height: 1.95;
  text-align: justify;
  text-indent: 2em;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.overview-text:last-of-type {
  margin-bottom: 0;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin-top: 24px;
}

.summary-card {
  padding: 16px 18px;
  border-radius: 10px;
  background: rgba(255, 248, 239, 0.92);
  border: 1px solid rgba(242, 92, 25, 0.08);
}

.summary-card__label {
  margin: 0 0 6px;
  color: #b28a56;
  font-size: 12px;
  line-height: 1.4;
  letter-spacing: 0.12em;
}

.summary-card__title {
  margin: 0 0 8px;
  color: #2f2419;
  font-size: 18px;
  line-height: 1.5;
  font-family: 'Songti SC', 'STSong', 'Noto Serif SC', serif;
}

.summary-card__desc {
  margin: 0;
  color: #5d5145;
  font-size: 13px;
  line-height: 1.7;
}

.entry-section__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 20px;
  margin-bottom: 22px;
}

.entry-section__note {
  margin: 0;
  color: #7b6a56;
  font-size: 13px;
  line-height: 1.6;
}

.entry-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
}

.entry-card {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: 172px;
  padding: 20px 22px;
  border-radius: 12px;
  border: 1px solid rgba(179, 145, 101, 0.18);
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 10px 24px rgba(45, 33, 16, 0.05);
  text-decoration: none;
  transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease;
}

.entry-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 28px rgba(45, 33, 16, 0.08);
  border-color: rgba(242, 92, 25, 0.22);
}

.entry-card__tag {
  margin: 0;
  color: #b28a56;
  font-size: 12px;
  line-height: 1.4;
  letter-spacing: 0.12em;
}

.entry-card__title {
  margin: 0;
  color: #2c2218;
  font-size: 22px;
  line-height: 1.45;
  font-family: 'Songti SC', 'STSong', 'Noto Serif SC', serif;
}

.entry-card__desc {
  margin: 0;
  color: #5f5347;
  font-size: 14px;
  line-height: 1.8;
}

.entry-card__more {
  margin-top: auto;
  color: #f25c19;
  font-size: 14px;
  line-height: 1.6;
  font-weight: 600;
}

@media (max-width: 1024px) {
  .group_5 {
    flex-direction: column;
    gap: 24px;
  }

  .sidebar-slot,
  .content-slot {
    width: 100%;
    flex-basis: auto;
  }

  .entry-section__header {
    flex-direction: column;
    align-items: start;
  }
}

@media (max-width: 768px) {
  .block_3 {
    padding-bottom: 52px;
  }

  .overview-card,
  .entry-section {
    padding: 20px;
  }

  .summary-grid,
  .entry-grid {
    grid-template-columns: 1fr;
  }

  .entry-card {
    min-height: auto;
  }
}
</style>
